
const firebaseConfig = {
  apiKey: "AIzaSyAB3SeuiYiCiB6B5ACNHuKAUcS6CDe_fps",
  authDomain: "sabaseba-90786.firebaseapp.com",
  projectId: "sabaseba-90786",
  storageBucket: "sabaseba-90786.firebasestorage.app",
  messagingSenderId: "958434122328",
  appId: "1:958434122328:web:83c28925bed1308dd5882d",
  measurementId: "G-3QCNZTSK5M"
};

export default firebaseConfig;